export default function ManajemenContentIcon(props) {
  return (
    <svg {...props} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.99984 13.3359H11.6665V11.6693H4.99984V13.3359ZM13.3332 13.3359H14.9998V11.6693H13.3332V13.3359ZM4.99984 10.0026H6.6665V8.33594H4.99984V10.0026ZM8.33317 10.0026H14.9998V8.33594H8.33317V10.0026ZM3.33317 16.6693C2.87484 16.6693 2.48248 16.5061 2.15609 16.1797C1.8297 15.8533 1.6665 15.4609 1.6665 15.0026V5.0026C1.6665 4.54427 1.8297 4.15191 2.15609 3.82552C2.48248 3.49913 2.87484 3.33594 3.33317 3.33594H16.6665C17.1248 3.33594 17.5172 3.49913 17.8436 3.82552C18.17 4.15191 18.3332 4.54427 18.3332 5.0026V15.0026C18.3332 15.4609 18.17 15.8533 17.8436 16.1797C17.5172 16.5061 17.1248 16.6693 16.6665 16.6693H3.33317ZM3.33317 15.0026H16.6665V5.0026H3.33317V15.0026Z"
        fill="currentColor"
      />
    </svg>
  );
}
